import React from "react";
//import "./OverlayLegend.css"; // Import the CSS file

interface OverlayLegendProps {
  selectedOverlay: string
}

const OverlayLegend: React.FC<OverlayLegendProps> = ({ selectedOverlay }) => {

    // Define legend categories
  const legendItems = [
    { label: "WSA Area", color : "#337ab7" },
    { label: "Thrust Fault", color: "#337ab7" },
    { label: "Normal Fault", color: "#5bc0de" },
    { label: "Low Angle Detachment Fault", color: "#5cb85c" },
    { label: "Fault", color: "#f0ad4e" },
    { label: "Undefined Fault", color: "#d9534f" },
    { label: "Coastline", color: "#edfb30" },
  ];
  // Color mapping for different WSA sizes
  const wsaColors = [
    { label: "Very Small", color : '#337ab7'},
    { label: "Small", color : '#7b739c'},
    { label: "Medium", color : '#a06b83'},
    { label: "Large", color : '#c06068'},
    { label: "Very Large", color : '#d9534f'}
    ];

  return (
    <div className="overlay-legend">
      {/* WSA Legend */}
      {selectedOverlay === "WSA" && (
        <div className="legend-section">
          <div className="legend-title">WSA</div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: wsaColors[0].color, border: "1px solid black" }}></span> Very Small
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: wsaColors[1].color, border: "1px solid black"  }}></span> Small
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: wsaColors[2].color, border: "1px solid black"  }}></span> Medium
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: wsaColors[3].color, border: "1px solid black"  }}></span> Large
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: wsaColors[4].color, border: "1px solid black"  }}></span> Very Large
          </div>
        </div>
      )}

      {/* Faults Legend */}
      {selectedOverlay === "Faults" && (
        <div className="legend-section">
          <div className="legend-title">Fault Lines</div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: legendItems[1].color, border: "1px solid black"  }}></span> Thrust Fault
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: legendItems[2].color, border: "1px solid black"  }}></span> Normal Fault
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: legendItems[3].color, border: "1px solid black"  }}></span> Low Angle Detachment Fault
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: legendItems[4].color, border: "1px solid black"  }}></span> Fault
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: legendItems[5].color, border: "1px solid black"  }}></span> Undefined Fault
          </div>
        </div>
      )}

      {/* Coast Legend */}
      {selectedOverlay === "Coastline" && (
        <div className="legend-section">
          <div className="legend-title">Coastline</div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: legendItems[6].color , border: "1px solid black" }}></span> Coastline
          </div>
        </div>
      )}

      {/* No overlay */}
      {selectedOverlay === "None" && (
        <div className="legend-section">
        </div>
      )}
    </div>
  );
};

export default OverlayLegend;
